<template>
    <div class="carousel-relative-container">

        <!-- Flecha izquierda -->
        <button class="btn-nav nav-left" @click="prev" :disabled="currentSlide === 0">
            <i class="bx bx-chevron-left"></i>
        </button>

        <!-- Grid de productos -->
        <div class="row g-3 px-md-5 w-100 mx-auto justify-content-center">
            <div v-for="producto in paginatedProducts" :key="producto.id"
                class="col-12 col-md-6 col-lg-3 d-flex align-items-stretch">
                <Cardsprodspresentation :info="producto" />
            </div>
        </div>

        <!-- Flecha derecha -->
        <button class="btn-nav nav-right" @click="next" :disabled="currentSlide === totalSlides - 1">
            <i class="bx bx-chevron-right"></i>
        </button>

    </div>
</template>

<script>
import Cardsprodspresentation from "./PresentacionProductos/cardsprods2.vue";

export default {
    name: "ProductsCarousel",
    components: {
        Cardsprodspresentation
    },

    props: {
        productos: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            currentSlide: 0,
            screenWidth: window.innerWidth
        };
    },

    computed: {
        itemsPerSlide() {
            if (this.screenWidth < 768) return 1;
            if (this.screenWidth < 992) return 2;
            return 4;
        },

        totalSlides() {
            return Math.ceil(this.productos.length / this.itemsPerSlide);
        },

        paginatedProducts() {
            const start = this.currentSlide * this.itemsPerSlide;
            return this.productos.slice(start, start + this.itemsPerSlide);
        }
    },

    methods: {
        next() {
            if (this.currentSlide < this.totalSlides - 1) {
                this.currentSlide++;
            }
        },

        prev() {
            if (this.currentSlide > 0) {
                this.currentSlide--;
            }
        },

        onResize() {
            this.screenWidth = window.innerWidth;
            this.currentSlide = 0;
        }
    },

    mounted() {
        window.addEventListener("resize", this.onResize);
    },

    beforeUnmount() {
        window.removeEventListener("resize", this.onResize);
    },

    watch: {
        productos() {
            this.currentSlide = 0;
        }
    }
};
</script>

<style scoped>
/* =====================================
   CONTENEDOR DEL CARRUSEL
===================================== */
.carousel-relative-container {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 10px;
}

/* =====================================
   BOTONES DE NAVEGACIÓN
===================================== */
.btn-nav {
    width: 40px;
    height: 40px;
    background-color: var(--surface-primary);
    border: 1px solid var(--border-light);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--title2-color-secciones);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;
    z-index: 10;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.btn-nav:hover:not(:disabled) {
    background-color: var(--title2-color-secciones);
    color: var(--title9-color);
}

.btn-nav:disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

/* =====================================
   POSICIÓN LATERAL
===================================== */
.nav-left {
    left: 0;
}

.nav-right {
    right: 0;
}
</style>